import { useState } from 'react';
import { useDispatch } from 'react-redux';
import UserApi from '../../../../../API/user/user-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { TextArea } from '../../../../../components/Basic/Inputs';
import { H2 } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import styles from './styles.module.scss';

const DisputePenaltyPopUp = ({ user = {}, penalty = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState('');

  let onClickOk = () => {
    console.log(penalty);
    UserApi.changePenalty({
      data: {
        penaltyId: penalty._id,
        field: 'protest',
        value: { comment },
      }
    }).then((r) => close());
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Оспорить штраф</H2>
      <TextArea
        value={comment}
        placeholder="Введите комментарий"
        width="500px"
        onChange={(v) => setComment(v)}
        minRow={4}
        maxRow={6}
        style={{ marginTop: '15px' }}
      />

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          onClick={onClickOk}
          disabled={comment.length < 5}
        >
          Отправить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DisputePenaltyPopUp;
